/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
import { App } from '../App'
import { AppRedirect } from '../pages/AppRedirect'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser, isFacilityManager, auth } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='app-redirect' element={<AppRedirect />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              {(isFacilityManager && auth?.data?.isSwitchAccount === true && (
                <Route path='auth/switch-account' element={<AuthPage />} />
              )) ||
                false}
              {/* <Route index element={<Navigate to='/dashboard' />} /> */}
              <Route
                index
                element={
                  <Navigate to={(currentUser as any)?.userType === 'SPONSOR' ? '/My-impact' : '/dashboard'} />
                }
              />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
